import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/motorista' };
/////////////////////////////////////////////////////////////////////////////////

export function createMotoristaCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateMotoristaCadastro(payload) {
  const { id } = payload;

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listMotoristaCadastro(param) {
  return httpService.get({ ...args, args: param });
}

export function findMotoristaCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllMotoristaCadastro() {
  return httpService.get({ ...args, path: '/motorista/all' });
}

export function deleteMotoristaCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

export function filterMotoristaCadastro(idPropriedade, where) {
  return httpService.get({
    ...args,
    args: `?propriedade=${idPropriedade}${where}`,
  });
}